import { render, staticRenderFns } from "./DesignerDetail.vue?vue&type=template&id=6d6625de"
import script from "./DesignerDetail.vue?vue&type=script&lang=js"
export * from "./DesignerDetail.vue?vue&type=script&lang=js"
import style0 from "./DesignerDetail.vue?vue&type=style&index=0&id=6d6625de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports